import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  height: 100vh;
  width: 100vw;
  position: relative;

  .logo-container {
    position: relative;
    top: 30px;
    left: 30px;
    display: block;
  }

  .SaasOnboardingPricingTiers-container {
    padding-top: 120px;
  }

  .asterisk-text {
    padding-top: ${spacing(6)};
  }

  .footer {
    margin-top: ${spacing(12)};
    padding-bottom: ${spacing(15)};
  }
`
